/**
 * House関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _InvoiceAutomationState = {
  account_id: null,
  status: null,
  min_price: null
}

const STATUS_LABEL_AUTO = '自動実行'
const STATUS_VALUE_AUTO = 'auto'
const STATUS_LABEL_MANUAL = '手動実行'
const STATUS_VALUE_MANUAL = 'manual'
const STATUS_LABEL_DISABLED = '実行しない'
const STATUS_VALUE_DISABLED = 'disabled'

class InvoiceAutomationState extends Record(_InvoiceAutomationState) {
  getStatusLabel() {
    switch (this.status) {
      case 'disabled':
        return STATUS_LABEL_DISABLED
      case 'manual':
        return STATUS_LABEL_MANUAL
      case 'auto':
        return STATUS_LABEL_AUTO
      default:
        return '不明'
    }
  }

  getOptions() {
    if (this.status === STATUS_VALUE_AUTO) {
      return [
        { label: STATUS_LABEL_AUTO, value: STATUS_VALUE_AUTO },
        { label: STATUS_LABEL_MANUAL, value: STATUS_VALUE_MANUAL },
        { label: STATUS_LABEL_DISABLED, value: STATUS_VALUE_DISABLED }
      ]
    }
    if (this.status === STATUS_VALUE_MANUAL) {
      return [
        { label: STATUS_LABEL_MANUAL, value: STATUS_VALUE_MANUAL },
        { label: STATUS_LABEL_DISABLED, value: STATUS_VALUE_DISABLED }
      ]
    }
    return [{ label: STATUS_LABEL_DISABLED, value: STATUS_VALUE_DISABLED }]
  }

  getDisabledOption() {
    return { label: STATUS_LABEL_DISABLED, value: STATUS_VALUE_DISABLED }
  }
}

export { InvoiceAutomationState }
